module.exports = __webpack_public_path__ + "img/volvo-penta.fdd481b2.svg";